
export enum SellingMethod {
  Auction= 'Auction',
  DirectSale= 'DirectSale',
  OfflineSale= 'OfflineSale',

}